<div class="bg-gray-100" *ngIf="mediaItem">
  <div class="thumb" *ngIf="previewImage; else mediaTemplate">
    <img
      class="product-image product-image-ratio"
      [src]="mediaItem.previewImage.url"
      [alt]="alt || mediaItem.previewImage.altText || mediaItem.alt || fallbackAlt"
      [class.object-fit-cover]="mediaItem.mediaContentType.toLowerCase() === 'video'"
      [srcset]="srcSetAttr"
      [sizes]="sizesAttr"
      loading="lazy"
      width="600"
      height="750"
    />
    <app-icon class="thumb__icon-overlay" *ngIf="mediaItem.mediaContentType.toLowerCase() === 'video'" [anchor]="'icon-play'"></app-icon>
  </div>

  <ng-template #mediaTemplate>
    <ng-container [ngSwitch]="mediaItem.mediaContentType">
      <!--<div *ngSwitchCase="'EXTERNALVIDEO'"></div>-->
      <!--<div *ngSwitchCase="'MODEL3D'"></div>-->
      <ng-container *ngSwitchCase="'VIDEO'">
        <fstr-html5-video
          class="product-video-ratio"
          *ngIf="mediaItem?.sources?.[0]?.url"
          [src]="mediaItem!.sources![0]!.url"
          [playsinline]="true"
          (ready)="videoReady($event)"
          [playerVars]="playerVars"
        ></fstr-html5-video>
      </ng-container>

      <ng-container *ngSwitchDefault>
        <img
          [ngClass]="productImage ? 'product-image product-image-ratio' : ''"
          [src]="mediaItem.previewImage.url"
          [alt]="alt || mediaItem.previewImage.altText || mediaItem.alt || fallbackAlt"
          [srcset]="srcSetAttr"
          [sizes]="sizesAttr"
          loading="lazy"
          width="600"
          height="750"
        />
      </ng-container>
    </ng-container>
  </ng-template>
</div>
